import React, { FC } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment/moment';

import { fc } from 'i18n';
import { IDraftForm } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';

import styles from './styles.module.css';

interface ICellProps {
  rowIndex: number;
}

export const Until: FC<ICellProps> = ({ rowIndex }) => {
  const { formState, control } = useFormContext<IDraftForm>();

  const startOn: Date | undefined = useWatch({ control, name: `leases.${rowIndex}.startOn` });

  const error = formState.errors.leases?.[rowIndex]?.endOn?.message;

  const disabledDate = (date: Date) => moment(date).isBefore(moment(startOn || new Date()), 'day');

  return (
    <Controller
      control={control}
      name={`leases.${rowIndex}.endOn`}
      rules={{ required: fc('please enter end date') }}
      defaultValue={null}
      render={({ value, onChange }) => (
        <div className={styles.datePicker}>
          <DatePicker placeholder={fc('end date')} value={value} onChange={onChange} disabledDate={disabledDate} />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  );
};
